import React from 'react'
import PropTypes from 'prop-types'
import OverviewDetailItem from './OverviewDetailItem'

const OverviewDetailItems = ({ supplier: { foundingYear, employeeCount, annualRevenue, duns } }) => {
  if (foundingYear || employeeCount || annualRevenue || duns) {
    return (
      <div className='grid-x' id='supplier-detail-items'>
        <div className='medium-3 small-6 cell border-right small-border-bottom'>
          <OverviewDetailItem
            title='Founded'
            value={foundingYear}
          />
        </div>
        <div className='medium-3 small-6 cell border-right small-border-bottom'>
          <OverviewDetailItem
            title='DUNS Number'
            value={duns}
          />
        </div>
        <div className='medium-3 small-6 cell border-right'>
          <OverviewDetailItem
            title='Company Size'
            value={employeeCount}
          />
        </div>
        <div className='medium-3 small-6 cell'>
          <OverviewDetailItem
            title='Annual Revenue'
            value={annualRevenue || ''}
          />
        </div>
      </div>
    )
  } else {
    return (<></>)
  }
}

OverviewDetailItems.propTypes = {
  supplier: PropTypes.shape({
    foundingYear: PropTypes.number,
    employeeCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    annualRevenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    duns: PropTypes.string
  })
}

OverviewDetailItems.defaultProps = {
  supplier: { foundingYear: null, employeeCount: null, annualRevenue: null, duns: null }
}

export default OverviewDetailItems
